import AllowContactByPhoneFieldSet from '../AllowContactByPhone/components/AllowContactByPhoneFieldSet';
import DateAvailableFormField from '../WhenIsPropertyAvailable/components/DateAvailableFormField';
import EmailFormField from '../ContactInfo/components/EmailFormField';

import ForRentByFieldSet from '../ForRentBy/components/ForRentByFieldSet';

import RoomForRentByFieldSet from '../RoomForRentBy/components/RoomForRentByFieldSet';

import LeaseTermsFormField from '../LeaseTerms/components/LeaseTermsFormField';
import RentersInsuranceFieldSet from '../LeaseTerms/components/RentersInsuranceFieldSet';

import LeaseDurationFieldSet from '../LeaseDuration/components/LeaseDurationFieldSet';

import MinimumIncomeRatioFormSectionContainer from '../LCIncome/components/MinimumIncomeRatioFormSectionContainer';

import MinimumCreditScoreFormSectionContainer from '../LCCreditScore/components/MinimumCreditScoreFormSectionContainer';

import LCPetPolicyFormSectionContainer from '../LCPetPolicy/components/LCPetPolicyFormSectionContainer';
import MonthlyRentFormField from '../MonthlyRent/components/MonthlyRentFormField';
import RoomUtilitiesAmountFormField from '../RoomUtilitiesAmount/components/RoomUtilitiesAmountFormField';
import NameFormField from '../ContactInfo/components/NameFormField';
import PetPolicyFormField from '../PetPolicy/components/PetPolicyFormField';
import PhoneNumberFormField from '../PhoneNumber/components/PhoneNumberFormField';
import PropertyDescriptionFormField from '../DescribeProperty/components/PropertyDescriptionFormField';

import SecurityDepositFormField from '../SecurityDeposit/components/SecurityDepositFormField';

import PropertyTypeFormField from '../PropertyType/components/PropertyTypeFormField';
import HideAddressFormField from '../HidePropertyAddress/components/HideAddressReviewFormField';

import TotalRoommateCountFormSectionContainer from '../RoomHowManyRoommates/components/TotalRoommateCountFormSectionContainer';

import DetailedRoommateCountFormSectionContainer from '../RoomHowManyRoommates/components/DetailedRoommateCountFormSectionContainer';

import RoommateDescriptionFormField from '../RoommateDescription/components/RoommateDescriptionFormField';

import GenderPreferenceFormField from '../RenterPreferences/components/GenderPreferenceFormField';

import RoomCurrentPetsFormSectionContainer from '../RoomCurrentPets/components/RoomCurrentPetsFormSectionContainer';
import SquareFootageFormField from '../PropertyDescription/components/SquareFootageFormField';
import RoomSquareFootageFormField from '../PropertyDescription/components/RoomSquareFootageFormField';
import BedroomsFormField from '../PropertyDescription/components/BedroomsFormField';
import BathroomsFormField from '../PropertyDescription/components/BathroomsFormField';
import AddressFormField from '../PropertyDescription/components/AddressFormField';
import AcceptApplicationsContentWithFields from '../AcceptZillowApplications/components/AcceptApplicationsContentWithFields';
import SpecialOfferFormField from '../../SpecialOfferFormField';
import AmenitiesPropertyFormField from '../../../components/WizardModularListing/AmenitiesProperty/components/AmenitiesPropertyFormField';
import AmenitiesInteriorFormField from '../../../components/WizardModularListing/AmenitiesInterior/components/AmenitiesInteriorFormField';
import AdditionalAmenitiesFormField from '../../../components/WizardModularListing/AddAmenities/components/AddAmenitiesFormField';
import { default as FinancialExpectationsFormSectionContainer } from '../FinancialExpectations/components/FormSectionContainer';

import { default as PetsAllowedFormSectionContainer } from '../PetPolicyAndPetFee/components/FormSectionContainer';

const MODAL_COMPONENT = {
  AddressFormField: {
    title: 'Edit address',
    component: AddressFormField,
    componentKey: 'AddressFormField',
  },
  BathroomsFormField: {
    title: 'Bathrooms',
    component: BathroomsFormField,
    componentKey: 'BathroomsFormField',
  },
  BedroomsFormField: {
    title: 'Bedrooms',
    component: BedroomsFormField,
    componentKey: 'BedroomsFormField',
  },
  SquareFootageFormField: {
    title: 'Square footage',
    component: SquareFootageFormField,
    componentKey: 'SquareFootageFormField',
  },
  RoomSquareFootageFormField: {
    title: 'Room square footage',
    component: RoomSquareFootageFormField,
    componentKey: 'RoomSquareFootageFormField',
  },
  HideAddressFormField: {
    title: 'Hide property address',
    component: HideAddressFormField,
    componentKey: 'HideAddressFormField',
  },
  TotalRoommateCountFormSectionContainer: {
    title: 'Roommate count',
    component: TotalRoommateCountFormSectionContainer,
    componentKey: 'TotalRoommateCountFormSectionContainer',
  },
  DetailedRoommateCountFormSectionContainer: {
    title: 'Roommate count',
    component: DetailedRoommateCountFormSectionContainer,
    componentKey: 'DetailedRoommateCountFormSectionContainer',
  },
  RoommateDescriptionFormField: {
    title: 'Roommates description',
    component: RoommateDescriptionFormField,
    componentKey: 'RoommateDescriptionFormField',
  },
  GenderPreferenceFormField: {
    title: 'Roommates description',
    component: GenderPreferenceFormField,
    componentKey: 'GenderPreferenceFormField',
  },
  RoomCurrentPetsFormSectionContainer: {
    title: 'Pets currently on the property',
    component: RoomCurrentPetsFormSectionContainer,
    componentKey: 'RoomCurrentPetsFormSectionContainer',
  },
  PropertyTypeFormField: {
    title: 'Property type',
    component: PropertyTypeFormField,
    componentKey: 'PropertyTypeFormField',
  },
  MonthlyRentFormField: {
    title: 'Monthly rent',
    component: MonthlyRentFormField,
    componentKey: 'MonthlyRentFormField',
  },
  MonthlyRentFormField_TMP: {
    title: 'Base rent',
    component: MonthlyRentFormField,
    componentKey: 'MonthlyRentFormField_TMP',
  },
  SpecialOfferFormField: {
    title: 'Special offer',
    component: SpecialOfferFormField,
    componentKey: 'SpecialOfferFormField',
  },
  RoomUtilitiesAmountFormField: {
    title: 'Utilities',
    component: RoomUtilitiesAmountFormField,
    componentKey: 'RoomUtilitiesAmountFormField',
  },
  SecurityDepositFormField: {
    title: 'Security deposit',
    component: SecurityDepositFormField,
    componentKey: 'SecurityDepositFormField',
  },
  PetPolicyFormField: {
    title: 'Pets',
    component: PetPolicyFormField,
    componentKey: 'PetPolicyFormField',
  },
  PropertyDescriptionFormField: {
    title: 'Property description',
    component: PropertyDescriptionFormField,
    componentKey: 'PropertyDescriptionFormField',
  },
  LeaseTermsFormField: {
    title: 'Lease terms',
    component: LeaseTermsFormField,
    componentKey: 'LeaseTermsFormField',
  },
  RentersInsuranceFieldSet: {
    title: 'Renters insurance',
    component: RentersInsuranceFieldSet,
    componentKey: 'RentersInsuranceFieldSet',
  },
  LeaseDurationFieldSet: {
    title: 'Lease duration',
    component: LeaseDurationFieldSet,
    componentKey: 'LeaseDurationFieldSet',
  },
  MinimumIncomeRatioFormSectionContainer: {
    title: 'Minimum monthly income',
    component: MinimumIncomeRatioFormSectionContainer,
    componentKey: 'MinimumIncomeRatioFormSectionContainer',
  },
  MinimumCreditScoreFormSectionContainer: {
    title: 'Minimum credit score',
    component: MinimumCreditScoreFormSectionContainer,
    componentKey: 'MinimumCreditScoreFormSectionContainer',
  },
  LCPetPolicyFormSectionContainer: {
    title: 'Pet policy',
    component: LCPetPolicyFormSectionContainer,
    componentKey: 'LCPetPolicyFormSectionContainer',
  },
  DateAvailableFormField: {
    title: 'Date available',
    component: DateAvailableFormField,
    componentKey: 'DateAvailableFormField',
  },
  AmenitiesInteriorFormField: {
    title: 'Interior amenities',
    component: AmenitiesInteriorFormField,
    componentKey: 'AmenitiesInteriorFormField',
  },
  AmenitiesPropertyFormField: {
    title: 'Property amenities',
    component: AmenitiesPropertyFormField,
    componentKey: 'AmenitiesPropertyFormField',
  },
  AmenitiesAdditionalFormField: {
    title: 'Additional amenities',
    component: AdditionalAmenitiesFormField,
    componentKey: 'AmenitiesAdditionalFormField',
  },
  FinancialExpectationsFormSectionContainer: {
    title: 'Financial expectations',
    component: FinancialExpectationsFormSectionContainer,
    componentKey: 'FinancialExpectationsFormSectionContainer',
  },
  PetsAllowedFormSectionContainer: {
    title: 'Pets',
    component: PetsAllowedFormSectionContainer,
    componentKey: 'PetsAllowedFormSectionContainer',
  },
  ForRentByFieldSet: {
    title: 'Listed by',
    component: ForRentByFieldSet,
    componentKey: 'ForRentByFieldSet',
  },
  RoomForRentByFieldSet: {
    title: 'Listed by',
    component: RoomForRentByFieldSet,
    componentKey: 'RoomForRentByFieldSet',
  },
  NameFormField: {
    title: 'Name',
    component: NameFormField,
    componentKey: 'NameFormField',
  },
  EmailFormField: {
    title: 'Email',
    component: EmailFormField,
    componentKey: 'EmailFormField',
  },
  PhoneNumberFormField: {
    title: 'Phone',
    component: PhoneNumberFormField,
    componentKey: 'PhoneNumberFormField',
  },
  AllowContactByPhoneFieldSet: {
    title: 'Allow renters to contact you by phone',
    component: AllowContactByPhoneFieldSet,
    componentKey: 'AllowContactByPhoneFieldSet',
  },
  AcceptZillowApplicationsFieldSet: {
    title: 'Zillow applications',
    component: AcceptApplicationsContentWithFields,
    componentKey: 'AcceptZillowApplicationsFieldSet',
  },
};

const LEASE_DURATION: Record<string, string> = {
  '1mo': '1 month',
  '6mo': '6 months',
  '1y': '1 year',
  r2o: 'Rent-to-own',
  sub: 'Sublet/temporary',
};

const PET_POLICY = {
  none: 'No pets allowed',
  // deprecated
  cats: 'Cats allowed',
  catsDto: 'Cats allowed',
  // deprecated
  smallDogs: 'Small dogs allowed',
  smallDogsDto: 'Small dogs allowed',
  // deprecated
  largeDogs: 'Large dogs allowed',
  largeDogsDto: 'Large dogs allowed',
};

const FOR_RENT_BY: Record<string, string> = {
  owner: 'Owner',
  ownerResident: 'Owner-resident',
  agent: 'Management Company or Broker',
  tenant: 'Tenant',
};

const ALLOW_CONTACT_BY_PHONE: Record<string, string> = {
  false: 'No',
  true: 'Yes',
};

const RECEIVE_ZILLOW_APPLICATIONS: Record<string, string> = {
  false: 'No',
  true: 'Yes',
};

const RENTERS_INSURANCE: Record<string, string> = {
  false: 'Not required',
  true: 'Required',
};

export {
  ALLOW_CONTACT_BY_PHONE,
  FOR_RENT_BY,
  LEASE_DURATION,
  MODAL_COMPONENT,
  PET_POLICY,
  RECEIVE_ZILLOW_APPLICATIONS,
  RENTERS_INSURANCE,
};
